import { Button } from "@shared/components";
import { useBonuses } from "@shared/hooks/bonuses";
import { useLobbyParams } from "@shared/hooks/lobby";
import { $f } from "@shared/hooks/shared";
import { useUser } from "@shared/hooks/user";
import { root } from "@shared/utils";
import { determinateCurrency } from "@shared/utils/sweepstakes";
import { isNull } from "lodash-es";
import React, { memo } from "react";
import { FormattedMessage } from "react-intl";
import Modal from "react-modal";

type TProps = {
  takeBonus: () => void;
  hideBonusModal: () => void;
};
export const BonusModal = memo(({ takeBonus, hideBonusModal }: TProps) => {
  const { bonus } = useBonuses() ?? {};
  const { currency } = useUser();
  const money = $f.formatMoney($f.toMoney(bonus?.amount));
  const { sweepstakes: isSweepstakesEnabled } = useLobbyParams() ?? {};
  return (
    <Modal
      isOpen={!isNull(bonus)}
      contentLabel="Bonus Modal"
      overlayClassName="bonus-modal"
      className="bonus-modal__content"
      appElement={root as HTMLElement}
      onRequestClose={hideBonusModal}
    >
      <div className="modal modal_slide_down modal_login">
        <FormattedMessage id="boilerplate.components.BonusModal.Title">
          {(message) => <b className="modal__title">{message} </b>}
        </FormattedMessage>
        <div className="modal__body">
          <p className="modal__paragraph">
            <FormattedMessage id="boilerplate.components.BonusModal.Amount">
              {(message) => <b>{message}</b>}
            </FormattedMessage>
            : {determinateCurrency(isSweepstakesEnabled, currency)} {money}
          </p>

          <p className="modal__paragraph">
            <FormattedMessage id="boilerplate.components.BonusModal.BonusType">
              {(message) => <b>{message}</b>}
            </FormattedMessage>
            : {bonus?.type}
          </p>
        </div>

        <div className="bonus-modal__buttons">
          <Button
            tagName="button"
            variant="secondary"
            type="submit"
            onClick={takeBonus}
          >
            <FormattedMessage id="boilerplate.components.BonusModal.TakeButton" />
          </Button>

          <Button
            tagName="button"
            variant="primary"
            type="submit"
            onClick={hideBonusModal}
          >
            <FormattedMessage id="boilerplate.components.BonusModal.NotNowButton" />
          </Button>
        </div>
        <div className="bonus-modal__present-image" />
      </div>
    </Modal>
  );
});

BonusModal.displayName = "BonusModal";
